import { createTheme } from '@mui/material';

import { DefaultTheme } from '@types';

import { defaultTheme } from './default-theme';

const lightTheme = createTheme(defaultTheme) as DefaultTheme;

export { lightTheme };
